import { render, staticRenderFns } from "./SystemGoods.vue?vue&type=template&id=9dc2f91a&scoped=true&"
import script from "./SystemGoods.vue?vue&type=script&lang=js&"
export * from "./SystemGoods.vue?vue&type=script&lang=js&"
import style0 from "./SystemGoods.vue?vue&type=style&index=0&id=9dc2f91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc2f91a",
  null
  
)

export default component.exports